module.exports = __webpack_public_path__ + "img/76342.788e4f7f.svg";